import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// Self-hosted brand font (Plus Jakarta Sans). Bundled rather than loaded
// from a CDN so the login surface has no third-party dependency on the
// auth path. Weights: 400 body, 500 controls, 600 headings, 700 emphasis,
// 800 for the brand headline (BRAND.md: headlines are ExtraBold 800).
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import './index.css';

const ROOT_ELEMENT_ID = 'root';

const rootElement = document.getElementById(ROOT_ELEMENT_ID);
if (!rootElement) {
  throw new Error(`Cloud-auth-ui mount point #${ROOT_ELEMENT_ID} is missing.`);
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
